/** Options for cohort + underwriting Excel sheets from a saved QCF model state. */
export function buildCohortExportOptionsFromState(
  state,
  { scorecardConfig = null, hillModel = null, companyName = null } = {}
) {
  if (!state?.cohortSheet?.cohorts?.length) {
    return null;
  }
  return {
    companyName: companyName ?? null,
    monthlyOpex: state.opex,
    beginCash: state.beginCash,
    netBurn: state.netBurn,
    runway: state.runway,
    runwaySource: state.runwaySource,
    predictedRunoff: state.predictedRunoff,
    predictedRunoffSource: state.predictedRunoffSource,
    lastMarketingSpend: state.lastMarketingSpend,
    maxMarketingRoas100: state.maxMarketingRoas100,
    debt: state.debt,
    totalAssets: state.totalAssets,
    totalAssetsSource: state.totalAssetsSource,
    totalLiabilities: state.totalLiabilities,
    totalLiabilitiesSource: state.totalLiabilitiesSource,
    safe: state.safe,
    revenueGrowthYoy: state.revenueGrowthYoy,
    revenueGrowthYoySource: state.revenueGrowthYoySource,
    hillModel,
    scorecardConfig,
    accountingSnapshot: state.accountingSnapshot,
    investorScore: state.investorScore,
    managementScore: state.managementScore,
    stressTestingScore: state.stressTestingScore,
  };
}
